import * as XLSX from "xlsx";

/** Exporta linhas (já no formato de tela) para um .xlsx no browser. */
export function exportRowsToXlsx(
  rows: Record<string, unknown>[],
  fileName: string,
): void {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}
